import React from 'react';
import { motion } from 'framer-motion';
import { gridItems } from '../data/data';
import { staggerContainer, fadeInUp } from '../lib/motion';

const AboutCards = () => {
  return (
    <section id="about" className="py-24 bg-[#f8f8f6]">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8 mb-20">
          <div className="col-span-12 lg:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
            >
              <p className="text-xs uppercase tracking-widest text-[#666666] mb-4" style={{ fontFamily: 'var(--font-sans)' }}>
                About
              </p>
              <h2 className="text-5xl font-normal text-[#1a1a1a]" style={{ fontFamily: 'var(--font-serif)' }}>
                Approach
              </h2>
            </motion.div>
          </div>
        </div>

        <motion.div
          className="grid grid-cols-12 gap-y-20 lg:gap-x-8"
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-100px" }}
        >
          {gridItems.map((item, index) => (
            <motion.div
              key={index}
              variants={fadeInUp}
              className="col-span-12 lg:col-span-4 group"
            >
              <motion.div
                className="border-t border-[#d4d4d0] pt-6"
                whileHover={{ y: -4, transition: { duration: 0.3 } }}
              >
                <h3 className="text-2xl font-normal text-[#1a1a1a] mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
                  {item.title}
                </h3>
                <p className="text-base text-[#666666] leading-relaxed" style={{ fontFamily: 'var(--font-sans)', fontWeight: 300 }}>
                  {item.description}
                </p>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutCards;